import React, { useState, useEffect } from 'react';
import { Container, Grid, Paper } from '@material-ui/core';
import { OTT } from 'Components/Helper/Messages';
import HOCLoader from 'Components/Loader/HOCLoader';
import { Select as OPERATOR_SELECT_BY_SERVICEID } from 'Components/Api/OperatorsApi';
import { useLocation } from 'react-router';

import { PrimaryButton } from 'Components/Inputes/CustomButton';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { useHistory } from 'react-router-dom';
import { LOGOUT } from 'ConstComponents';
const CustomContainer = HOCLoader(Container);

export const OTTTransactionApp = ({ ServiceIDString }) => {
    const classes = commonStyle();
    const history = useHistory();
    const location = useLocation();
    const [value, setValue] = useState(OTT.toString());
    const [loadingOpen] = useState(false);
    const [responseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [Operator, setOperator] = useState([]);
    const [severity] = useState('success');

    useEffect(() => {
        let { state } = location;

        if (state === null) {
            return;
        }

        if (!state) return;
        let { ServiceID } = state;
        setValue(ServiceID);
    }, [location]);

    useEffect(() => {
        selectOperator(OTT);
    }, []);

    const selectOperator = async (ServiceID) => {
        if (
            ServiceID === null ||
            ServiceID === undefined ||
            ServiceID === 0 ||
            ServiceID === '0'
        )
            return;

        var requestObj = {
            ServiceID: ServiceID
        };

        var request = JSON.stringify(requestObj);

        const response = await OPERATOR_SELECT_BY_SERVICEID(request);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) setIsError(true);

        if (response.data !== 'Requested operators not found') {
            var data = JSON.parse(response.data);
            setOperator(data);
        }
    };

    const handleOperator = (operator) => {
        if (operator.OperatorName === 'Bundle') {
            let param = {
                OperatorID: operator.OperatorID
            };
            history.push('/OTTTransactionBundleAPP', param);
            return;
        }
        if (operator.OperatorName === 'Subscription') {
            let param = {
                OperatorID: operator.OperatorID
            };
            history.push('/OTTTransactionSubscriptionAPP', param);
            return;
        }
    };

    return (
        <CustomContainer
            isLoading={loadingOpen}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                style={{ marginTop: '10px' }}
            >
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Paper>
                            {Operator.map((operator, index) => (
                                <Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    lg={12}
                                    style={{
                                        marginTop: '5%'
                                    }}
                                >
                                    <PrimaryButton
                                        onClick={() => {
                                            handleOperator(operator);
                                        }}
                                        title={operator.OperatorName}
                                        className={
                                            classes.CustomPrimaryButtonStyle
                                        }
                                        fullWidth
                                        disabled={loadingOpen}
                                    >
                                        {operator.OperatorName}
                                    </PrimaryButton>
                                </Grid>
                            ))}
                        </Paper>
                    </Grid>
                </Grid>
            </Grid>
        </CustomContainer>
    );
};
